import {
  AddSVG,
  AISVG,
  AnalysisSVG,
  AnnouncementSVG,
  ArchiveBoxSVG,
  BankingBuildingSVG,
  BlockChainSVG,
  BookmarkSVG,
  BooksSVG,
  BreifcaseDollarSVG,
  BreifcaseGroupSVG,
  BriefcaseSVG,
  BulbSVG,
  CancelSVG,
  ChatSVG,
  CheckSVG,
  ClockSVG,
  CloseBtnSVG,
  CloudComputingSVG,
  CurrencySVG,
  DashboardSVG,
  DataAnalyticsSVG,
  DownloadSVG,
  EditSVG,
  FacebookSVG,
  FilterSVG,
  FinancialAnalystSVG,
  GivingMoneySVG,
  GlobeSVG,
  GraduationSVG,
  GraphSVG,
  GroupSVG,
  GuidanceOfficeSVG,
  HandShakeRoundedSVG,
  HandShakeSVG,
  InkSVG,
  LawSVG,
  LeavePageSVG,
  LeftQuoteSVG,
  LinkedinSVG,
  LinkSVG,
  MediaSVG,
  MoneyChequeSVG,
  MonitorSVG,
  NoteOutlinedSVG,
  NoteSimpleSVG,
  NoteSVG,
  OfficeBuildingSVG,
  OfficerSVG,
  PageSettingsSVG,
  PagesSVG,
  PersonWithCurrencySVG,
  PhoneSVG,
  ResearchSecuritySVG,
  ResearchSVG,
  RightArrowSVG,
  RolledNewspaperSVG,
  RupeeSVG,
  SearchCatalogueSVG,
  SearchPageSVG,
  SecuritySVG,
  SelfServiceSVG,
  SendSVG,
  StarPointSVG,
  StudentSVG,
  SupplyChainSVG,
  SupplyLogisticsSVG,
  SupportSVG,
  TargetSVG,
  TeachingSVG,
  TelevisionSVG,
  telSVG,
  TutorSVG,
  UploadSVG,
  UserKeySVG,
  UserLeaderSVG,
  UserPodiumSVG,
  UserSettingSVG,
  UserThoughtSVG,
  VectorSVG,
  VerifiedSVG,
  WhatsAppSVG,
} from "../src/assets/favicons"; // Import your SVG components

type SVGProps = { color: string; width: string; height: string };

export const iconMap: { [key: string]: React.FC<SVGProps> } = {
  student: StudentSVG,
  tutor: TutorSVG,
  breifcase: BriefcaseSVG,
  clock: ClockSVG,
  globe: GlobeSVG,
  rupee: RupeeSVG,
  books: BooksSVG,
  monitor: MonitorSVG,
  graph: GraphSVG,
  bulb: BulbSVG,
  group: GroupSVG,
  target: TargetSVG,
  download: DownloadSVG,
  graduation: GraduationSVG,
  currency: CurrencySVG,
  chat: ChatSVG,
  star_3D: StarPointSVG,
  note: NoteSVG,
  send: SendSVG,
  support: SupportSVG,
  upload: UploadSVG,
  verified: VerifiedSVG,
  leave_page: LeavePageSVG,
  delete: ArchiveBoxSVG,
  edit: EditSVG,
  add: AddSVG,
  check: CheckSVG,
  cancel: CancelSVG,
  close: CloseBtnSVG,
  filter: FilterSVG,
  bookmark: BookmarkSVG,
  dashboard: DashboardSVG,
  pages: PagesSVG,
  link: LinkSVG,
  facebook: FacebookSVG,
  linkedin: LinkedinSVG,
  whatsapp: WhatsAppSVG,
  phone: PhoneSVG,
  noteOutlined: NoteOutlinedSVG,
  noteSimple: NoteSimpleSVG,
  ink: InkSVG,
  searchPage: SearchPageSVG,
  personWithCurrency: PersonWithCurrencySVG,
  handShake: HandShakeSVG,
  searchCatalogue: SearchCatalogueSVG,
  userKey: UserKeySVG,
  announcement: AnnouncementSVG,
  userThought: UserThoughtSVG,
  research: ResearchSVG,
  media: MediaSVG,
  television: TelevisionSVG,
  researchSecurity: ResearchSecuritySVG,
  officer: OfficerSVG,
  userPodium: UserPodiumSVG,
  HandShakeRounded: HandShakeRoundedSVG,
  userLeader: UserLeaderSVG,
  breifcaseDollar: BreifcaseDollarSVG,
  breifcaseGroup: BreifcaseGroupSVG,
  supplyChain: SupplyChainSVG,
  pageSettings: PageSettingsSVG,
  cloudComputing: CloudComputingSVG,
  security: SecuritySVG,
  dataAnalytics: DataAnalyticsSVG,
  ai: AISVG,
  blockChain: BlockChainSVG,
  userSetting: UserSettingSVG,
  guidanceOffice: GuidanceOfficeSVG,
  supportSVG: SupportSVG,
  officerSVG: OfficerSVG,
  financialAnalyst: FinancialAnalystSVG,
  officeBuilding: OfficeBuildingSVG,
  bankingBuilding: BankingBuildingSVG,
  analysis: AnalysisSVG,
  supplyLogistics: SupplyLogisticsSVG,
  teaching: TeachingSVG,
  rolledNewspaper: RolledNewspaperSVG,
  selfService: SelfServiceSVG,
  law: LawSVG,
  moneyCheque: MoneyChequeSVG,
  givingMoney: GivingMoneySVG,
  vector: VectorSVG,
  leftQuote: LeftQuoteSVG,
  rightArrow: RightArrowSVG,
  tel: telSVG,
};
